import { render, staticRenderFns } from "./EventPasses.vue?vue&type=template&id=67dda77f"
import script from "./EventPasses.vue?vue&type=script&lang=js"
export * from "./EventPasses.vue?vue&type=script&lang=js"
import style0 from "./EventPasses.vue?vue&type=style&index=0&id=67dda77f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports